import React from 'react';

// Context used to transmit a form reference to children
export const FormRefContext = React.createContext('');

// Context used to transmit a subform reference to children
export const SubFormRefContext = React.createContext('');

// Context used to transmit a list reference to children
export const ListRefContext = React.createContext('');

// Context used to transmit a `disabled` value
export const DisabledContext = React.createContext(false);

// Context used to transmit a `max width` value
export const MaxWidthContext = React.createContext(null);

// Context used to transmit CPM carpark attributes
export const CpmCarparkContext = React.createContext(null);

// Context used to transmit OPAC installation attributes
export const OpacInstallationContext = React.createContext(null);

// Context used to transmit CPM client attributes
export const CpmClientContext = React.createContext(null);



// WEBPACK FOOTER //
// ./components/misc/Contexts.js